import { Collection, Select, MultilineInput, NumberInput, TextInput, CollectionPrinter, RefJsonViewer, Button } from "@tblabs/truffle";
import { ProductSelector } from "../../../../Components/ProductSelector";
import { BasketItemType } from "../../../../Models/Basket/BasketItemType";
import { RentBasketItem } from "../../../../Models/Basket/RentBasketItem";
import { SaleBasketItem } from "../../../../Models/Basket/SaleBasketItem";
import { AddToBasketStep } from "../../../../Steps/AddToBasket/AddToBasketStep";
import { Step } from "../../../../Steps/Step/Step";
import { TimeUtils } from "../../../../Utils/TimeUtils";
import { Entry } from "./Entry";
import { XButton } from "../../../../Components/Utils/XButton";
import { Icons } from "../../../../Components/Utils/Icons";
import { DateTimeEditInput } from "../../../../Components/Utils/DateSlider";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { ShopContent } from "../../../../Shop/ShopContent";


export class AddToBasketEntryEditBox extends Entry<Step<any>>
{
    constructor(private step: AddToBasketStep, private steps: Collection<Step<any>>, private _shop: ShopContent)
    {
        super(step, steps, []);

        this.AddInput("Stan", new Select(step.Data.State, step.AllStates));
        this.AddInput("Powód odrzucenia", new MultilineInput(step.Data.RejectionReason).Rows(4).Placeholder("Powód odrzucenia"));

        this.Content.Append(
            // new TableViewer(step.Data.BasketItems).FontSize(14)
            //     .AddColumn("Typ", x => new Span(BasketItemTypeLabels[x.Type]).WidthAuto())
            //     .AddColumn("Produkt", x => new ProductSelector(_shop.Products.Items, x))
            //     .AddColumn("Ilość", x => new NumberInput(x.Quantity))
            //     .AddColumn("Koszt", x => new NumberInput(x.TotalPrice))
            //     .AddColumn("Identyfikator", x => new TextInput(x.ProductSerialNumber))
            //     .AddColumn("Dostępne dane", x => new TextInput(x.AccessData))
            //     .AddColumn("Depozyt łącznie (w PLN)", x => new NumberInput((x as RentBasketItem).Deposit), x => x.Type === BasketItemType.Rent)
            //     .AddColumn("Początek użytkowania", x => new DateInput((x as RentBasketItem).From), x => x.Type === BasketItemType.Rent)
            //     .AddColumn("Koniec użytkowania", x => new DateInput((x as RentBasketItem).To), x => x.Type === BasketItemType.Rent)
            //     .AddColumn("Opcje", item => new Link("❌ Usuń").OnClick(() => step.Data.BasketItems.Remove(item)))
            //     .Build(),
            new CollectionPrinter(step.Data.BasketItems, x =>
                {
                    switch (x.Type)
                    {
                        case BasketItemType.Rent:
                            const rentItem = x as RentBasketItem;
                            return new Table([], [
                                [`Wypożyczenie`,""],
                                ["Produkt", new ProductSelector(_shop.Products.Items, rentItem)],
                                ["Unikalny numer", new TextInput(rentItem.ProductSerialNumber).Bold()],
                                ["Dane dostępowe", new TextInput(rentItem.AccessData)],
                                ["", new RefJsonViewer(rentItem.AccessData)],
                                ["Ilość", new NumberInput(rentItem.Quantity)],
                                ["Koszt", new NumberInput(rentItem.TotalPrice)],
                                ["Depozyt", new NumberInput(rentItem.Deposit)],
                                ["Początek użytkowania", new DateTimeEditInput(rentItem.From)],
                                ["Koniec użytkowania", new DateTimeEditInput(rentItem.To)],
                                ["Opcje", new Button("Usuń", () => step.Data.BasketItems.Remove(rentItem))],
                            ]).Background("#e8f4f7").Padding(16).BorderRadius(8)
    
                        case BasketItemType.Sale:
                            const saleItem = x as SaleBasketItem;
                            return new Table([], [
                                [`Sprzedaż`,""],
                                ["Produkt", new ProductSelector(_shop.Products.Items, saleItem)],
                                ["Unikalny numer", new TextInput(saleItem.ProductSerialNumber).Bold()],
                                ["Dane dostępowe", new TextInput(saleItem.AccessData)],
                                ["", new RefJsonViewer(saleItem.AccessData)],
                                ["Ilość", new NumberInput(saleItem.Quantity)],
                                ["Koszt", new NumberInput(saleItem.TotalPrice)],
                                ["Opcje", new Button("Usuń", () => step.Data.BasketItems.Remove(saleItem))],
                            ]).Background("#e8f4f7").Padding(16).BorderRadius(8)
                              
                        default:
                            return `No edit form for ${x.Type}`;
                    }
                }).Class("panels-container"),
            new XButton("light", "wynajem", Icons.Plus, () => this.AddRentItem()),
            new XButton("light", "sprzedaż", Icons.Plus, () => this.AddSaleItem()),
        );

        // this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
        this.SetTitle(step.GetFullTitle(), step.GetStateName());
    }

    private AddRentItem()
    {
        this.step.Data.BasketItems.Add(new RentBasketItem({
            Type: BasketItemType.Rent,
            Quantity: 1,
            TotalPrice: 0,
            ProductSerialNumber: "",
            From: new Date(),
            To: new Date(),
            Deposit: 300,
        }));
    }

    private AddSaleItem()
    {
        this.step.Data.BasketItems.Add(new SaleBasketItem({
            Type: BasketItemType.Rent,
            Quantity: 1,
            TotalPrice: 0,
            ProductSerialNumber: "",
        }));
    }
}
